/**
 * Per-block request-param augmentation.
 *
 * Some blocks need to send client-side state (e.g. localStorage) to the
 * API so the server can return data consistent with what the client has
 * already seen. Keeping this in a dedicated module lets BlockLoader stay
 * generic — it just asks "what extra params does this block need?".
 *
 * Each function: ({ clientId, memberId }) => Record<string, string> | null
 */

import { getStorageKey, getAnsweredFromStorage } from './quickPollStorage';

/**
 * Tell the API which quick-poll questions the client has already answered.
 * Anonymous users have no server-side tracking, so without this the API
 * keeps returning answered questions and BlockLoader renders an empty
 * block after expand.
 */
export function quickPollRequestParams({ clientId, memberId }) {
  if (!clientId) return null;
  const answeredIds = getAnsweredFromStorage(getStorageKey(clientId, memberId));
  if (answeredIds.length === 0) return null;
  return { answered_ids: answeredIds.join(',') };
}
